module.exports = __webpack_public_path__ + "static/media/meatman.9f5b5166.png";